import {
  betStore,
  BOG_LINE_GAME_TYPES,
  freeBetStore,
  gameConfigStore,
  isMobile,
  loadingStore,
  userSettingsStore,
} from '@pascal/pascal-core';

import { gameName } from '../enums';
import { resizeGameHandler } from '../helpers';
import { gameLiveConnection, gameService, registerApis, soundService } from '../services';
import { liveConnection } from './liveConnection';
import { doBetsStore, roundsInfoStore, roundTimeStore } from '../store';

export const init = () => {
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }

  userSettingsStore.setIsDarkModeOn(true);
  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    gameService,
    soundService,
    liveConnection,
    gameLiveConnection,
  });
  userSettingsStore.isDarkModeOn && document.documentElement.classList.add('dark');
  registerApis();
  gameConfigStore.initGameConfigs(
    {
      sectionCount: 1,
      bogLineGameTypeData: {
        gameType: BOG_LINE_GAME_TYPES.ONLY_MARKET,
        isUsedPlatformIntegrationLogic: true,
      },
      isUsedBogLineComponents: true,
      initPlatformMessageConfigs: true,
      isAllSectionWithCashOutButton: false,
      isUsedInputValidationFunctionality: false,
      isUsedRoundStartAndFinishedLogicAfterCashOut: false,
    },
    {
      onGameTypeChangeCallback: () => {
        loadingStore.updateLoading({ isGameInitialLoaded: false });
        betStore.setDemoBetHistory([]);
        doBetsStore.setBetAmount(0);
        roundsInfoStore.clearBetsState();
        doBetsStore.setIsRequiredRedrawGame(true);
        freeBetStore.resetActiveFreeBet();

        roundTimeStore.setTime(0);
        gameService.sendWorker(false);

        betStore.setLiveBets([]);
        freeBetStore.resetActiveFreeBet();
      },
      onFreeBetDeactivateCallback: () => {
        if (doBetsStore.betBlocksData && Object.values(doBetsStore.betBlocksData).length) {
          doBetsStore.resetBetBlocks();
        }
      },
      onFreeBetActivateCallback: () => {
        if (doBetsStore.betBlocksData && Object.values(doBetsStore.betBlocksData).length) {
          doBetsStore.resetBetBlocks();
        }
      },
    }
  );
};
